import { gql } from '@apollo/client'
import { OCCUPANCY_TO_USE_TENANT_FRAGMENT } from 'src/pages/Inbox/components/InboxBody/components/hooks/data/fragments'

export const GET_PERSON_CURRENT_BALANCE = gql`
  query GetPersonBalance($id: Int!) {
    person(id: $id) {
      id
      type
      account {
        is_pay_ready
      }
      unit_occupancy_tenants {
        ...occupancyToUseTenantFields
        unit_occupancy {
          id
          current_balance
          agency_payment
          is_active
          deleted
          status
          move_in
          move_out
        }
      }
    }
  }
  ${OCCUPANCY_TO_USE_TENANT_FRAGMENT}
`
